/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { CategoryViewModel } from './CategoryViewModel'; 

export function getCategoriesOptions(onSuccess?: (result: CategoryViewModel[]) => void) {
	return queryOptions({
		queryKey: ['categories'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/categories/viewmodels/getcategories/';
			const resp = await axios.get<CategoryViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}